import React from "react";
import "./FeatureGrid.css";

export default function FeatureGrid({ children }) {
  return (
    <div className="container fg-wrapper">
      <div className="fg-grid">{children}</div>
    </div>
  );
}
